export default __webpack_public_path__ + "static/media/1Vid.055cdb32.mp4";